import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { SyncJobViewModel, TriggerJobRequestModel } from '../business-entities/syncJob-view-model';
import { SyncJobDataService } from '../data-services/sync-job-data.service';

@Injectable({
  providedIn: 'root'
})
export class SyncJobService {

  syncJobList:SyncJobViewModel[]
  constructor(private service: SyncJobDataService) { }

  async getSyncJobList(): Promise<any> {


    await this.service
            .getSyncJobList()
            .then(
                (res: GenericResponse<Array<any>>) => {
                    this.syncJobList = res.responseObject;
                }
            );

        return this.syncJobList;
  }

  async triggerJob(model:TriggerJobRequestModel):Promise<any>
  {
    return this.service.triggerJob(model);
  }

}
